import SelectBox from '@/components/content/SelectBox'
import { Carrier } from '@/services/deliveryAreas/types'

export function SelectBoxCarrier({ value, onChange }: { value?: Carrier; onChange: (v: Carrier) => void }) {
  return (
    <SelectBox<Carrier>
      value={value}
      onChange={onChange}
      block
      options={[
        { label: 'HJ', value: 'HJ' },
        { label: 'JA', value: 'JA' },
      ]}
      placeholder="운송사를 선택해주세요."
    />
  )
}
